var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_820_60449)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "url(#paint0_linear_820_60449)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21,
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_820_60449",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 29.3333C27.0626 29.3333 31.1667 25.2293 31.1667 20.1667C31.1667 15.1041 27.0626 11 22 11C16.9374 11 12.8333 15.1041 12.8333 20.1667C12.8333 25.2293 16.9374 29.3333 22 29.3333Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2875 38.3625C8.66688 35.6455 10.7717 33.3636 13.3685 31.7696C15.9654 30.1757 18.953 29.3333 22 29.3333C25.0471 29.3333 28.0346 30.1757 30.6315 31.7696C33.2283 33.3636 35.3331 35.6455 36.7125 38.3625"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.39583 37.9098C6.14582 38.4023 6.34235 39.0042 6.83481 39.2542C7.32726 39.5042 7.92915 39.3076 8.17917 38.8152L6.39583 37.9098ZM35.8208 38.8152C36.0709 39.3076 36.6727 39.5042 37.1652 39.2542C37.6576 39.0042 37.8542 38.4023 37.6042 37.9098L35.8208 38.8152ZM43 22C43 33.598 33.598 43 22 43V45C34.7025 45 45 34.7025 45 22H43ZM22 43C10.402 43 1 33.598 1 22H-1C-1 34.7025 9.29745 45 22 45V43ZM1 22C1 10.402 10.402 1 22 1V-1C9.29745 -1 -1 9.29745 -1 22H1ZM22 1C33.598 1 43 10.402 43 22H45C45 9.29745 34.7025 -1 22 -1V1ZM30.1667 20.1667C30.1667 24.677 26.5103 28.3333 22 28.3333V30.3333C27.6149 30.3333 32.1667 25.7816 32.1667 20.1667H30.1667ZM22 28.3333C17.4897 28.3333 13.8333 24.677 13.8333 20.1667H11.8333C11.8333 25.7816 16.3851 30.3333 22 30.3333V28.3333ZM13.8333 20.1667C13.8333 15.6563 17.4897 12 22 12V10C16.3851 10 11.8333 14.5518 11.8333 20.1667H13.8333ZM22 12C26.5103 12 30.1667 15.6563 30.1667 20.1667H32.1667C32.1667 14.5518 27.6149 10 22 10V12ZM8.17917 38.8152C9.47495 36.2629 11.4522 34.1193 13.8917 32.6219L12.8454 30.9174C10.0912 32.608 7.85881 35.0282 6.39583 37.9098L8.17917 38.8152ZM13.8917 32.6219C16.3309 31.1247 19.1373 30.3333 22 30.3333V28.3333C18.7686 28.3333 15.5999 29.2267 12.8454 30.9174L13.8917 32.6219ZM22 30.3333C24.8627 30.3333 27.6691 31.1247 30.1083 32.6219L31.1546 30.9174C28.4001 29.2267 25.2314 28.3333 22 28.3333V30.3333ZM30.1083 32.6219C32.5478 34.1193 34.5251 36.2629 35.8208 38.8152L37.6042 37.9098C36.1412 35.0282 33.9088 32.608 31.1546 30.9174L30.1083 32.6219Z",
    fill: "white",
    mask: "url(#path-3-inside-1_820_60449)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21,
    stroke: "#C8E5BB",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_820_60449",
    x1: 7.7,
    y1: -8.06667,
    x2: 34.4667,
    y2: 48.7667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1FF91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#519834"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_820_60449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.0f069d6a4811d465f722a2d3f039f418.svg";
export { ForwardRef as ReactComponent };